import elecIconPic from '../img/boltInMarkerBackground.svg';
import handicapIconPic from '../img/handicapInMarker.svg';
import { useState } from 'react';

export function Dropdown()  {
  const [isClosed, setIsClosed] = useState(false);

  const toggleBox = () => {
    setIsClosed(prev => !prev);
  };

  const iconCode = isClosed ? '&#xe88e;' : '&#xe5cd;';

  return (
    <div className="dropdown-wrapper">
      <div
        className={`availability-box ${isClosed ? 'closed' : ''}`}
        style={isClosed ? { overflow: 'hidden', padding: '0' } : {}}
      >
        <div
          className="availability-closebutton"
          onClick={toggleBox}
          style={{
            cursor: 'pointer',
            opacity: isClosed ? 0.95 : 0.85,
          }}
        >
          <i
            className="material-icons"
            dangerouslySetInnerHTML={{ __html: iconCode }}
          />
        </div>

        {!isClosed && (
          <>
            <p className="availability-header">Tilgængelighed</p>
            <p className="m-1"><div className='box green'></div>Høj</p>
            <p className="m-1"><div className='box yellow'></div>Mellem</p>
            <p className="m-1"><div className='box red'></div>Lav</p>
            <p className="m-1"><div className='box blue'></div>Ingen live data</p>
            <p className="m-1"><div className='box eventred'></div>Event</p>
            <hr />
            <p className="m-1"><img src={handicapIconPic} alt="" width="25" height="25" /> Handicapparkering</p>
            <p className="m-1"><img src={elecIconPic} alt="" width="25" height="25" /> El ladestation</p>
          </>
        )}
      </div>
      <div
        className={`accessibility_statement_box ${isClosed ? 'closed' : ''}`}
      >
        {!isClosed && (
          <>
            <a
              className="availability-header"
              href="https://was.digst.dk/parkering-kolding-dk" 
              target="_blank"
              rel="noreferrer"
            >
              Tilgængelighedserklæring
            </a>
          </>
        )}
      </div>
    </div>
  );
}
